var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.block.class, {'half-padding-top': _vm.block.half_padding_top}, {'half-padding-bottom': _vm.block.half_padding_bottom}],attrs:{"id":_vm.block.anchor ? _vm.block.anchor : ('block-' + _vm.block.id)}},[_c('h2',{staticClass:"title"},[_vm._v(_vm._s(_vm.block.title))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ef27404","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/blocks/modules/Block.vue
// module id = null
// module chunks = 